import { FormInstance } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import PrimaryButton from "../../../commons/components/PrimaryButton/PrimaryButton";
import DaysSchedule from "./DaysSchedule";
import useSetHours from "./useSetHours";
import "./create-store.scss";

interface OpeningHoursProps {
  form: FormInstance;
  isUpdatingStore: boolean;
}
const OpeningHours: React.FC<OpeningHoursProps> = ({ form, isUpdatingStore }) => {
  const {
    handleSetDaysSchedule,
    listOpeningHours,
    OpeningHoursForm,
    handleDuplicate,
    setTrigger,
    trigger,
    listDaysHaveOpen,
    handleSetBreakSchedule,
    listBreakingHours,
    listDaysHaveBreak,
    isInside,
    setIsInside,
    handleSetBreakScheduleStatus,
  } = useSetHours(form, isUpdatingStore);

  return (
    <div
      onMouseLeave={() => {
        setIsInside(false);
      }}
      onMouseEnter={() => {
        setIsInside(true);
      }}
    >
      {OpeningHoursForm.map((item, idx) => {
        return (
          <>
            <div>
              <DaysSchedule
                isInSide={isInside}
                form={form}
                item={item}
                handleSetDaysSchedule={handleSetDaysSchedule}
                listOpeningHours={listOpeningHours}
                idx={idx}
                trigger={trigger}
                setTrigger={setTrigger}
                handleDuplicate={handleDuplicate}
                listDaysHaveOpen={listDaysHaveOpen}
                handleSetBreakSchedule={handleSetBreakSchedule}
                listBreakingHours={listBreakingHours}
                listDaysHaveBreak={listDaysHaveBreak}
                handleSetBreakScheduleStatus={handleSetBreakScheduleStatus}
              />
            </div>
          </>
        );
      })}
    </div>
  );
};

export default OpeningHours;
